import { cn } from "@/lib/utils";
import type { NotaStatus } from "@/lib/fiscal-types";

const STYLES: Record<NotaStatus, { bg: string; text: string; ring: string; glow: string; label: string }> = {
  AUTORIZADA: {
    bg: "bg-[linear-gradient(135deg,#1FE08F,#0FB36A)]",
    text: "text-white",
    ring: "ring-1 ring-[#1FE08F]/40",
    glow: "shadow-[0_0_18px_rgba(31,224,143,0.55)]",
    label: "AUTORIZADA",
  },
  CANCELADA: {
    bg: "bg-[linear-gradient(135deg,#FF5C6E,#C2293A)]",
    text: "text-white",
    ring: "ring-1 ring-[#FF5C6E]/40",
    glow: "shadow-[0_0_18px_rgba(255,92,110,0.55)]",
    label: "CANCELADA",
  },
  CONTINGENCIA: {
    bg: "bg-[linear-gradient(135deg,#FFC857,#E89C1B)]",
    text: "text-[#3A2300]",
    ring: "ring-1 ring-[#FFC857]/40",
    glow: "shadow-[0_0_18px_rgba(255,200,87,0.55)]",
    label: "AUT. EM CONTINGÊNCIA",
  },
  INUTILIZADA: {
    bg: "bg-[linear-gradient(135deg,#94A3B8,#475569)]",
    text: "text-white",
    ring: "ring-1 ring-[#94A3B8]/40",
    glow: "shadow-[0_0_14px_rgba(148,163,184,0.45)]",
    label: "INUTILIZADA",
  },
};

interface Props {
  status: NotaStatus;
  size?: "sm" | "md";
  className?: string;
}

export function StatusBadge({ status, size = "md", className }: Props) {
  const s = STYLES[status];
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center font-bold uppercase tracking-wide rounded-full",
        s.bg, s.text, s.ring, s.glow,
        size === "sm" ? "px-2 py-0.5 text-[9px]" : "px-2.5 py-0.5 text-[10px]",
        className,
      )}
    >
      {s.label}
    </span>
  );
}
